import { NavBar } from '@design-system/NavBar';
import { SendMyReportsPageReportFormSection } from '@/components/screens/SendMyReportsPage/SendMyReportsPageReportFormSection';

export const SendMyReportsPage = () => {
  return (
    <section className="page-container page-container flex flex-col">
      <NavBar
        className="mb-6 md:mb-16"
        buttonLabel={
          <span className="max-md:hidden">Settings & Information</span>
        }
      />

      <h1 className="typography-d2 lg:typography-d1 text-primary mb-6">
        Send My Reports
      </h1>

      <p className="text-secondary typography-body mb-8">
        Electing to share your Viome report means you voluntarily choose to
        disclose your personal health records, data, and accept full
        responsibility. Our system safeguards your personal data within the safe
        space of our app. Personal data includes your registration information,
        sample data, self-reported information, other types of collected
        personal information as defined by the Viome Privacy Policy.
      </p>

      <div className="w-full max-w-sm">
        <SendMyReportsPageReportFormSection />
      </div>
    </section>
  );
};
